import { clsx } from 'clsx';

const WarningIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.8 4L7.20001 4L7.20001 8.8L8.8 8.8L8.8 4ZM8 10.4C7.77334 10.4 7.5832 10.4768 7.4296 10.6304C7.276 10.784 7.19947 10.9739 7.2 11.2C7.20054 11.4261 7.27734 11.616 7.43041 11.7696C7.58347 11.9232 7.77334 12 8 12C8.22667 12 8.41654 11.9232 8.5696 11.7696C8.72267 11.616 8.79947 11.4261 8.8 11.2C8.80054 10.9739 8.72374 10.7837 8.5696 10.6296C8.41547 10.4755 8.2256 10.3989 8 10.4ZM8.00001 5.02266e-06C9.10667 5.11941e-06 10.1467 0.210139 11.12 0.630405C12.0933 1.05067 12.94 1.62054 13.66 2.34C14.38 3.05947 14.9499 3.90614 15.3696 4.88C15.7893 5.85387 15.9995 6.89387 16 8C16.0005 9.10614 15.7904 10.1461 15.3696 11.12C14.9488 12.0939 14.3789 12.9405 13.66 13.66C12.9411 14.3795 12.0944 14.9493 11.12 15.3696C10.1456 15.7899 9.1056 16 8 16C6.8944 16 5.85441 15.7899 4.88001 15.3696C3.90561 14.9493 3.05894 14.3795 2.34001 13.66C1.62107 12.9405 1.05094 12.0939 0.629609 11.12C0.208275 10.1461 -0.00159203 9.10613 8.32878e-06 8C0.00160869 6.89387 0.211742 5.85387 0.630408 4.88C1.04908 3.90614 1.61894 3.05947 2.34001 2.34C3.06107 1.62054 3.90774 1.0504 4.88001 0.629605C5.85227 0.208805 6.89227 -0.00106128 8.00001 5.02266e-06Z"
        fill="#C11A45"
      />
    </svg>
  );
};

export const Banner = ({ type = 'warning', text = <>Banner Text</>, className = '' }) => {
  const is = {
    warning: type === 'warning',
    info: type === 'info',
  };

  return (
    <div
      className={clsx(
        'flex z-50 py-3.5 items-center gap-2.5 backdrop-blur-md w-full justify-center',
        is.warning && 'bg-[#F0E2E6E5]',
        is.info && 'bg-[#F5FCFE] border-b border-b-[rgba(0,156,178,0.25)]',
        className,
      )}
    >
      {is.warning && <WarningIcon />}
      <p
        className={clsx(
          'font-medium text-xs',
          is.warning && 'text-[#C11A45]',
          is.info && 'text-[#009CB2]',
        )}
      >
        {text}
      </p>
    </div>
  );
};
